import Client from "../client/Livechat"

const resource = "/api/v1"

const getMessageLiveChat = (params) => {
  return Client.get(`${resource}/publish/chat/history`, { params })
}

const checkBan = () => {
  return Client.get(`${resource}/publish/chat/check-ban`)
}

const sendMessageLiveChat = (data) => {
  return Client.post(`${resource}/publish/chat`, data)
}

const LivechatRepository = {
  getMessageLiveChat,
  checkBan,
  sendMessageLiveChat
}
export default LivechatRepository
